import type { BlueprintColumnComponent } from '@/grove-blueprints/generated-types'

type ColumnAlignment = NonNullable<
  NonNullable<BlueprintColumnComponent['props']>['alignment']
>

const COLUMN_ALIGNMENT_CLASS: Record<ColumnAlignment, string> = {
  leading: 'items-start',
  center: 'items-center',
  trailing: 'items-end',
}

export function resolveColumnAlignment(
  alignment: ColumnAlignment | undefined,
): string {
  if (alignment === undefined) {
    return ''
  }

  return COLUMN_ALIGNMENT_CLASS[alignment]
}
